import client from '@libs/HttpClient';
class ActivityService {
  static listTask(request) {
    const projectId = request.id;
    const page_no = request.page_no;
    const selectedAssignee = request.selectedAssignee;
    const selectedSprint = request.selectedSprint;
    const selectedInactiveUser = request.selectedInactiveUser;
    return client.get(
      `/projects/view/${projectId}/activities?page=${page_no}&selectedAssignee=${selectedAssignee}&selectedSprint=${selectedSprint}&selectedInactiveUser=${selectedInactiveUser}`,
      request
    );
  }
}
export { ActivityService };